var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.6364C26 23.4091 20 27.5 20 27.5C20 27.5 14 23.4091 14 18.6364C14 17.0089 14.6321 15.4481 15.7574 14.2973C16.8826 13.1465 18.4087 12.5 20 12.5C21.5913 12.5 23.1174 13.1465 24.2426 14.2973C25.3679 15.4481 26 17.0089 26 18.6364Z",
    fill: "#2D4993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 20.6817C21.1055 20.6817 22.001 19.7659 22.001 18.6363C22.001 17.5066 21.1055 16.5908 20.001 16.5908C18.8964 16.5908 18.001 17.5066 18.001 18.6363C18.001 19.7659 18.8964 20.6817 20.001 20.6817Z",
    fill: "#F1F5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryMap);
export default __webpack_public_path__ + "static/media/summaryMap.343f23f001bc8ffe4e7a1252d8090699.svg";
export { ForwardRef as ReactComponent };